import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

/**
 * Allows employees through; redirects non-employees to the employer dashboard
 * and unauthenticated users to login.
 */
export const employeeOnly: CanMatchFn = () => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  if (!auth.isLoggedIn())   { return router.parseUrl('/auth/login'); }
  if (!auth.isEmployee())   { return router.parseUrl('/employer/dashboard'); }
  return true;
};
